import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { getPlanDiscountPercent } from '../../shared/plan-helpers';
import styles from './SubscriptionCard.css';

const cx = classnames.bind(styles);

function renderSubtitle(subscriptionData, withDiscount) {
    const weeks = subscriptionData.billingPeriod?.value;

    if (subscriptionData.trial) {
        return (
            <>
                <strong>{subscriptionData.trial.price}</strong>
                {' now, then '}
                <strong>{subscriptionData.price}</strong>
                {` every ${weeks} weeks`}
            </>
        );
    }

    if (withDiscount) {
        return (
            <>
                {'then '}
                <strong>{subscriptionData.price}</strong>
                {` every ${weeks} weeks`}
            </>
        );
    }

    return (
        <>
            <strong>{subscriptionData.price}</strong>
            {` every ${weeks} weeks`}
        </>
    );
}

function getPricePerDayLabel(subscriptionData) {
    const cents = subscriptionData.trial?.pricePerDay ?? subscriptionData.pricePerDay;

    return `$${(cents / 100).toFixed(2)}`;
}

function SubscriptionCard({ subscriptionData, selectedSubscriptionData, selectSubscription, isExpired = false, name = 'subscription-plan' }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const discountPercent = getPlanDiscountPercent(subscriptionData);
    const isDiscountShown = !isExpired && discountPercent > 0 && !subscriptionData.isDiscountBadgeHidden;

    return (
        <label className={cx('root', { popular: subscriptionData.isPopular })}>
            <input
                type='radio'
                name={name}
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>
                    <Icon name='starFilled' className={styles.starIcon} />
                    Best offer
                </div>
            )}
            <div className={styles.content}>
                {isDiscountShown && (
                    <span className={styles.discountBadge}>-{discountPercent}%</span>
                )}
                <span className={styles.radio}>
                    <span className={styles.radioDot} />
                </span>
                <div className={styles.planInfo}>
                    <p className={styles.name}>{subscriptionData.name}</p>
                    <p className={styles.subtitle}>{renderSubtitle(subscriptionData, !isExpired)}</p>
                </div>
                <div className={styles.priceTag}>
                    <div className={styles.priceNotch} />
                    <div className={styles.priceBox}>
                        <p className={styles.price}>{getPricePerDayLabel(subscriptionData)}</p>
                        <p className={styles.priceCaption}>breakdown<br />per day</p>
                    </div>
                </div>
            </div>
        </label>
    );
}

SubscriptionCard.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isExpired: PropTypes.bool,
    name: PropTypes.string
};

export {
    SubscriptionCard
};
